import { render, staticRenderFns } from "./DualListBox.vue?vue&type=template&id=53de6e32&"
import script from "./DualListBox.vue?vue&type=script&lang=js&"
export * from "./DualListBox.vue?vue&type=script&lang=js&"
import style0 from "./DualListBox.vue?vue&type=style&index=0&id=53de6e32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports